import React, { useEffect, useState } from "react";
import Firebase from "../../../firebasehelper";
import { brandMapping } from "../../../Utils/Constants";

export default function BrandLogo() {
  const [brandLogo, setBrandLogo] = useState("");

  const getBrandLogo = () => {
    const hostname = window.location.hostname.toLowerCase();

    const found = brandMapping.find((mapping) =>
      hostname.includes(mapping.substring)
    );

    if (found) {
      Firebase.getBrandDataByID(found.brandId, (res) => {
        setBrandLogo(res.logo);
      });
    }
  };

  useEffect(() => {
    getBrandLogo();
  }, []);

  return brandLogo ? (
    <img src={brandLogo} style={{ width: 300 }} alt="brand logo" />
  ) : null;
}



// WEBPACK FOOTER //
// ./src/screens/LogIn/components/BrandLogo.jsx